module.exports = __webpack_public_path__ + "img/desjardins_immobilier.703ad73b.png";